import { z } from "zod";
//#region src/app-capabilities.ts
/**
* The capability kinds a fixture can offer to an org (app-oidc, D2, D8).
*
* A fixture declares a capability in the `capabilities` block of its `fixture.json`. The operator
* program syncs each declaration into `release.app_capability_declarations` with its kind, and an
* org admin enables it in `release.org_app_capability_enablements` through
* `PUT /v1/admin/apps-catalog/:appId/capabilities`. Both tables carry a `capability_kind` CHECK,
* and this list is the vocabulary of that column.
*
* - `mcp`: one MCP endpoint of the fixture (`capabilities.mcp[]`), one row per endpoint id.
* - `oidc`: the platform OIDC surface of the fixture (`capabilities.oidc`), one row per fixture
*   under the id `OIDC_CAPABILITY_ID` of `oidc-app.ts`. One enablement covers `accept` and
*   `issue` (D8).
*
* Callers: `@zion/sdk-dp-admin-contracts` binds {@link appCapabilityKindSchema} on the capability
* routes; core-api (WS-2) widens its two kind CHECKs to this list; the operator program (WS-4)
* writes `oidc` rows. Pure: no I/O.
*/
/**
* Every capability kind, in the order the kinds arrived: `mcp` first, then `oidc`. A new kind goes
* at the end. The length of this list is the count of kinds.
*/
const APP_CAPABILITY_KINDS = ["mcp", "oidc"];
/**
* The zod enum of {@link APP_CAPABILITY_KINDS}. It refuses every other string, an upper-case
* spelling included, so a route that binds it answers 400 on an unknown kind (defaults row 3).
*/
const appCapabilityKindSchema = z.enum(APP_CAPABILITY_KINDS);
/** True when `value` is one of {@link APP_CAPABILITY_KINDS}. Never throws. Pure. */
function isAppCapabilityKind(value) {
	return appCapabilityKindSchema.safeParse(value).success;
}
//#endregion
export { APP_CAPABILITY_KINDS, appCapabilityKindSchema, isAppCapabilityKind };

//# sourceMappingURL=app-capabilities.js.map